import { inject, Injectable } from '@angular/core'
import { Database, ref, objectVal } from '@angular/fire/database'
import { Auth, signInWithEmailAndPassword } from '@angular/fire/auth'

import { map } from 'rxjs'

import { ValetServiceMonitoringResponse } from '@definitions/valet-service-monitoring'
import { OperatorDataState } from '@states/operator-data'

@Injectable({
	providedIn: 'root',
})
export class FirebaseService {
	readonly #auth = inject(Auth)
	readonly #database = inject(Database)
	readonly #operatorDataState = inject(OperatorDataState)

	firebaseAuth() {
		const { user: email, password } = this.#operatorDataState.firebaseUser()

		return signInWithEmailAndPassword(this.#auth, email, password).then(async cred => {
			await cred.user.getIdToken(true)

			return cred.user
		})
	}

	getData() {
		const { operatorCompanyId, parkingLocationId } = this.#operatorDataState.metadata()
		const path = `/parkingServices/operatorCompany/${operatorCompanyId}/parkingLot/${parkingLocationId}`
		const dataRef = ref(this.#database, path)

		return objectVal<ValetServiceMonitoringResponse>(dataRef).pipe(
			map(r => {
				return r?.ticket ?? null
			})
		)
	}
}
